module.exports = __webpack_public_path__ + "static/media/APCO Institute Logo_1719597699141.4b79ff67.png";